class MidwayTokenError extends Error {
  constructor() {
    super(`User is not authenticated with Midway`);
  }
}

export default MidwayTokenError;
